export const productsIt: Record<string, string> = {
  // Products
  'products.title': 'Prodotti',
  'products.description': 'Gestisci i tuoi prodotti e inventario',
  'products.showing': 'Mostrando {from}-{to} di {total} prodotti',
  'products.actions.import': 'Importa',
  'products.actions.export': 'Esporta',
  'products.actions.addProduct': 'Aggiungi Prodotto',
  'products.actions.edit': 'Modifica',
  'products.actions.retry': 'Riprova',
  'products.labels.stock': 'Scorte',
  'products.labels.sku': 'SKU',
  'products.labels.notAvailable': 'N/D',
  'products.labels.orders': 'Ordini',
  'products.labels.order': 'ordine',
  'products.categories.dress': 'Abito',
  'products.categories.veil': 'Velo',
  'products.categories.accessory': 'Accessorio',
  'products.categories.service': 'Servizio',
  'products.categories.shoes': 'Scarpe',
  'products.categories.jewelry': 'Gioielli',
  'products.categories.bag': 'Borsa',
  'products.categories.underwear': 'Biancheria',
  'products.categories.wedding-dress': 'Abito da Sposa',
  'products.categories.evening-dress': 'Abito da Sera',
  'products.categories.groom-suits': 'Abiti Sposo',
  'products.categories.bridal-shoes': 'Scarpe da Sposa',
  'products.categories.bridesmaid-dress': 'Abito Damigella',
  'products.categories.mother-of-bride': 'Abito Mamma Sposa',
  'products.categories.bridal-lingerie': 'Lingerie Sposa',
  'products.categories.bridal-jewelry': 'Gioielli Sposa',
  'products.categories.bridal-accessories': 'Accessori Sposa',
  'products.categories.alteration-services': 'Servizi Sartoria',
  'products.collectionYears.2020-2021': '2020-2021',
  'products.collectionYears.2021-2022': '2021-2022',
  'products.collectionYears.2022-2023': '2022-2023',
  'products.collectionYears.2023-2024': '2023-2024',
  'products.collectionYears.2024-2025': '2024-2025',
  'products.collectionYears.2025-2026': '2025-2026',
  'products.collectionYears.2026-2027': '2026-2027',
  'products.collectionYears.2027-2028': '2027-2028',
  'products.table.image': 'Immagine',
  'products.table.product': 'Prodotto',
  'products.table.category': 'Categoria',
  'products.table.brand': 'Marca',
  'products.table.price': 'Prezzo',
  'products.table.stock': 'Scorte',
  'products.table.actions': 'Azioni',
  'products.table.orders': 'Ordini',
  'products.table.sku': 'SKU',
  'products.table.name': 'Nome',
  'products.table.sellingPrice': 'Prezzo di Vendita',
  'products.table.costPrice': 'Prezzo di Costo',
  'products.table.internalNote': '(interno)',
  'products.search.placeholder': 'Cerca prodotti...',
  'products.filters.title': 'Filtri',
  'products.filters.clearAll': 'Cancella Tutto',
  'products.filters.searchLabel': 'Cerca',
  'products.filters.search': 'Cerca prodotti...',
  'products.filters.searchByNameBrandSku': 'Cerca per nome, marca o SKU...',
  'products.filters.searchBadge': 'Ricerca: {query}',
  'products.filters.noResults': 'Nessun prodotto trovato corrispondente ai filtri',
  'products.filters.activeFilters': 'Filtri attivi:',
  'products.filters.category': 'Categoria',
  'products.filters.brand': 'Marca',
  'products.filters.color': 'Colore',
  'products.filters.sellingPriceRange': 'Gamma Prezzo Vendita (€)',
  'products.filters.costPriceRange': 'Gamma Prezzo Costo (€)',
  'products.filters.priceRangeLabel': 'Intervallo prezzo: EUR {min} - EUR {max}',
  'products.filters.costPriceRangeLabel': 'Intervallo prezzo costo: EUR {min} - EUR {max}',
  'products.filters.priceBadge': 'Prezzo: EUR {min} - {max}',
  'products.filters.infinity': 'Nessun max',
  'products.filters.advancedFilters': 'Filtri Avanzati',
  'products.filters.sizeRange': 'Gamma Taglie',
  'products.filters.supplier': 'Fornitore',
  'products.filters.stockOptions': 'Opzioni Inventario',
  'products.filters.stockAvailableRange': 'Gamma Stock Disponibile',
  'products.filters.quantityOnHandRange': 'Gamma Quantità Disponibile',
  'products.filters.orderCountRange': 'Gamma Conteggio Ordini',
  'products.filters.collectionYear': 'Anno Collezione',
  'products.filters.allCollectionYears': 'Tutti gli anni di collezione',
  'products.filters.min': 'Min',
  'products.filters.max': 'Max',
  'products.filters.allCategories': 'Tutte le categorie',
  'products.filters.allBrands': 'Tutte le marche',
  'products.filters.allColors': 'Tutti i colori',
  'products.filters.allSizes': 'Tutte le taglie',
  'products.filters.allSuppliers': 'Tutti i fornitori',
  'products.filters.allProducts': 'Tutti i prodotti',
  'products.filters.trackStock': 'Traccia Inventario',
  'products.filters.allowNegative': 'Consenti Negativo',
  'products.filters.allowNegativeStock': 'Consenti stock negativo',
  'products.filters.hasImages': 'Ha immagini',
  'products.filters.imageFilter': 'Filtro Immagini',
  'products.filters.withImages': 'Con immagini',
  'products.filters.withoutImages': 'Senza immagini',
  'products.filters.noBrand': 'Senza Marca',
  'products.filters.selling': 'Vendita',
  'products.filters.cost': 'Costo',
  'products.filters.minCurrency': 'Min EUR',
  'products.filters.maxCurrency': 'Max EUR',
  'products.filters.loadError': 'Impossibile caricare le opzioni filtro',
  'products.filters.loadErrorSub': 'Alcuni filtri potrebbero non essere disponibili',
  'products.filters.apply': 'Applica',
  'products.sort.recentlyUpdated': 'Aggiornati di Recente',
  'products.sort.nameAsc': 'Nome A-Z',
  'products.sort.nameDesc': 'Nome Z-A',
  'products.sort.priceAsc': 'Prezzo Crescente',
  'products.sort.priceDesc': 'Prezzo Decrescente',
  'products.sort.recentlyCreated': 'Creati di Recente',
  'products.sort.ordersAsc': 'Ordini (Crescente)',
  'products.sort.ordersDesc': 'Ordini (Decrescente)',
  'products.empty.title': 'Nessun prodotto trovato',
  'products.empty.withFilters': 'Nessun prodotto corrisponde ai filtri attuali.',
  'products.empty.noFilters': 'Non hai ancora prodotti. Creane uno per iniziare.',
  'products.empty.clearFilters': 'Cancella Filtri',
  'products.empty.createProduct': 'Crea Prodotto',
  'products.errors.loadingTitle': 'Errore Caricamento Prodotti',
  'products.errors.loadingDescription': 'Si è verificato un errore durante il caricamento dei prodotti',
  'products.errors.tryAgain': 'Riprova',
  'products.errors.loadFailed': 'Impossibile caricare i prodotti',
  'products.errors.nameRequired': 'Il nome del prodotto è obbligatorio',
  'products.errors.duplicateSku': 'SKU già esistente. Utilizzare un SKU univoco.',
  'products.errors.permissionDenied': "Permesso negato. Controllare le impostazioni dell'organizzazione.",
  'products.errors.missingField': 'Campo obbligatorio mancante. Controllare tutti i campi obbligatori.',
  'products.errors.invalidSupplier': 'Fornitore selezionato non valido. Scegliere un fornitore valido.',
  'products.errors.updateFailed': 'Impossibile aggiornare il prodotto',
  'products.errors.cannotDelete': 'Impossibile Eliminare',
  'products.errors.referencedByOrders': 'Questo prodotto è referenziato da ordini esistenti e non può essere eliminato',
  'products.errors.deleteFailed': 'Impossibile eliminare il prodotto',
  'products.errors.noCostPricePermission': 'Nessun permesso per visualizzare il prezzo di costo',
  'products.pagination.show': 'Mostra',
  'products.pagination.perPage': 'per pagina',
  'products.export.success': 'Esportazione Riuscita',
  'products.export.successDescription': '{count} prodotti esportati con successo',
  'products.export.error': 'Errore Esportazione',
  'products.export.errorDescription': "Si è verificato un errore nell'esportazione dei prodotti",
  'products.export.noData': 'Nessun Dato da Esportare',
  'products.export.noDataDescription': 'Nessun prodotto da esportare con i filtri attuali',
  'products.import.success': 'Importazione Riuscita',
  'products.import.successDescription': 'Prodotti importati con successo',
  'products.import.title': 'Importa Prodotti',
  'products.import.templateTab': 'Template',
  'products.import.uploadTab': 'Carica',
  'products.import.previewTab': 'Anteprima',
  'products.import.resultsTab': 'Risultati',
  'products.import.templateDescription': 'Scarica il template CSV con le colonne richieste',
  'products.import.downloadTemplate': 'Scarica Template',
  'products.import.requiredFields': 'Campi obbligatori: Nome, Categoria, Prezzo',
  'products.import.categories': 'Categorie: Abito, Velo, Accessorio, Servizio',
  'products.import.booleans': 'Valori Booleani: VERO/FALSO, true/false, sì/no, 1/0',
  'products.import.services': 'Servizi: Automaticamente impostati come articoli non di magazzino',
  'products.import.uploadDescription': 'Carica un file CSV con i tuoi prodotti',
  'products.import.uploadFilePrompt': 'Clicca per caricare file CSV',
  'products.import.fileSizeSupport': 'File CSV fino a 10MB supportati',
  'products.import.createMissingSuppliers': 'Crea fornitori mancanti',
  'products.import.previewData': 'Anteprima Dati',
  'products.import.processing': 'Elaborazione...',
  'products.import.importing': 'Importazione...',
  'products.import.importProducts': 'Importa {count} Prodotti',
  'products.import.toCreate': 'da creare',
  'products.import.toUpdate': 'da aggiornare',
  'products.import.errors': 'errori',
  'products.import.readyToImport': 'Pronto per importare',
  'products.import.hasErrors': 'Ha errori',
  'products.import.importingProducts': 'Importazione prodotti...',
  'products.import.importSuccess': 'Importazione completata con successo! I tuoi prodotti sono stati aggiunti al catalogo.',
  'products.import.created': 'Creati',
  'products.import.updated': 'Aggiornati',
  'products.import.viewProducts': 'Visualizza Prodotti',
  'products.import.rowNumber': 'Riga',
  'products.import.status': 'Stato',
  'products.import.name': 'Nome',
  'products.import.category': 'Categoria',
  'products.import.price': 'Prezzo',
  'products.import.message': 'Messaggio',
  'products.import.statusCreate': 'Crea',
  'products.import.statusUpdate': 'Aggiorna',
  'products.import.statusError': 'Errore',
  'products.import.cancel': 'Annulla',
  'products.import.import': 'Importa Prodotti',
  'products.import.error': 'Errore importazione',
  'products.import.downloadErrorReport': 'Scarica Rapporto Errori',
  'products.import.errorReportDownloaded': 'Rapporto errori scaricato',
  'products.import.errorReportDownloadSuccess': 'Il rapporto errori è stato scaricato con successo',
  'products.import.downloadFailed': 'Scaricamento fallito',
  'products.import.errorReportDownloadFailed': 'Impossibile scaricare il rapporto errori',
  'products.import.previewGenerated': 'Anteprima generata',
  'products.import.previewDescription': 'Caricate {rows} righe per anteprima',
  'products.import.importCompleted': 'Importazione completata',
  'products.import.importSuccessDescription': 'Creati {created}, aggiornati {updated} prodotti',
  'products.import.importFailed': 'Importazione fallita',
  'products.import.dragDrop': 'Trascina e rilascia il tuo file CSV qui, oppure',
  'products.import.selectFile': 'seleziona file',
  'products.import.supportedFormats': 'Formati supportati: CSV (max 10MB)',
  'products.import.csvTemplate': 'Scarica Template CSV',
  'products.import.requirements': 'Requisiti File',
  'products.import.req1': 'Il file deve essere in formato CSV',
  'products.import.req2': 'Colonne richieste: Nome, SKU, Categoria, Prezzo',
  'products.import.req3': 'Gli SKU devono essere unici',
  'products.import.req4': 'I prezzi devono essere numeri validi',
  'products.import.invalidFileType': 'Tipo di file non valido',
  'products.import.selectCsvFile': 'Seleziona un file CSV',
  'products.import.fileTooLarge': 'File troppo grande',
  'products.import.fileSizeLimit': 'File CSV fino a 10MB supportati',
  'products.import.permissionDenied': 'Permesso negato',
  'products.import.productsWriteRequired': 'Permesso di scrittura prodotti richiesto',
  'products.import.suppliersWriteRequired': 'Permesso di scrittura fornitori richiesto per creare fornitori mancanti',
  'products.import.authRequired': 'Autenticazione richiesta',
  'products.import.loginRequired': 'Accedi per scaricare il rapporto errori',
  'products.import.mobileNote': 'Solo i campi principali sono visibili su mobile. Dettagli completi disponibili su desktop.',
  'products.import.row': 'Riga',
  'import.template.downloaded': 'Template scaricato',
  'import.template.downloadSuccess': 'Il template CSV è stato scaricato con successo',
  'import.preview.status.ok': 'Crea',
  'import.preview.status.update': 'Aggiorna',
  'import.preview.status.error': 'Errore',
  'import.preview.noData': 'Nessun dato di anteprima disponibile',
  'import.preview.mobileNote': "L'anteprima mobile mostra solo i campi principali",
  'import.preview.row': 'Riga',
  'importHistory.title': 'Cronologia Importazioni',
  'importHistory.quickDescription': 'Visualizza la tua recente attività di importazione prodotti',
  'importHistory.viewAll': 'Visualizza Tutto',
  'products.csvHeaders.name': 'Nome',
  'products.csvHeaders.sku': 'SKU',
  'products.csvHeaders.category': 'Categoria',
  'products.csvHeaders.brand': 'Marca',
  'products.csvHeaders.price': 'Prezzo',
  'products.csvHeaders.costPrice': 'Prezzo di Costo',
  'products.csvHeaders.quantityOnHand': 'Quantità Disponibile',
  'products.csvHeaders.sizeRange': 'Gamma Taglie',
  'products.csvHeaders.colour': 'Colore',
  'products.csvHeaders.supplierId': 'ID Fornitore',
  'products.csvHeaders.description': 'Descrizione',
  'products.csvHeaders.createdAt': 'Creato il',
  'products.csvHeaders.updatedAt': 'Aggiornato il',
  'products.stats.hide': 'Nascondi statistiche',
  'products.stats.show': 'Mostra statistiche',
  'products.stats.totalProducts': 'Prodotti Totali',
  'products.stats.lowStock': 'Scorte Basse',
  'products.stats.outOfStock': 'Esaurito',
  'products.stats.withImages': 'Con Immagini',
  'products.stats.noImages': 'Senza Immagini',
  'products.stats.noBrand': 'Senza Marca',
  'products.columns.toggle': 'Colonne',
  'products.create.title': 'Crea Nuovo Prodotto',
  'products.create.name': 'Nome Prodotto',
  'products.create.namePlaceholder': 'Inserisci nome prodotto',
  'products.create.sku': 'SKU',
  'products.create.skuPlaceholder': 'ABITO001',
  'products.create.category': 'Categoria',
  'products.create.categoryPlaceholder': 'Seleziona categoria',
  'products.create.brand': 'Marca',
  'products.create.brandPlaceholder': 'Seleziona marca',
  'products.create.brandDeprecated': 'Brand (Deprecated)',
  'products.create.brandDeprecatedPlaceholder': 'Optional legacy brand text',
  'products.create.colour': 'Colore',
  'products.create.colourPlaceholder': 'Inserisci colore',
  'products.create.sizeRange': 'Gamma Taglie',
  'products.create.sizeRangePlaceholder': '6-20',
  'products.create.price': 'Prezzo',
  'products.create.pricePlaceholder': '0.00',
  'products.create.costPrice': 'Prezzo di Costo',
  'products.create.costPricePlaceholder': '0.00',
  'products.create.trackStock': 'Traccia Inventario',
  'products.create.allowNegativeStock': 'Consenti Stock Negativo',
  'products.create.stockAvailable': 'Scorte Disponibili',
  'products.create.quantityOnHand': 'Quantità in Magazzino',
  'products.create.supplier': 'Fornitore',
  'products.create.supplierPlaceholder': 'Seleziona fornitore',
  'products.create.collection': 'Collezione',
  'products.create.collectionPlaceholder': 'Inserisci nome collezione',
  'products.create.collectionYear': 'Anno Collezione',
  'products.create.collectionYearPlaceholder': 'Seleziona anno collezione',
  'products.create.description': 'Descrizione',
  'products.create.descriptionPlaceholder': 'Inserisci descrizione del prodotto',
  'products.create.cancel': 'Annulla',
  'products.create.creating': 'Creazione...',
  'products.create.create': 'Crea Prodotto',
  'products.create.success': 'Prodotto creato con successo',
  'products.create.error': 'Errore nella creazione del prodotto',
  'products.create.trackStockDescription': 'Monitora i livelli di inventario',
  'products.create.allowNegativeDescription': 'Consenti vendita eccessiva',
  'products.tabs.details': 'Dettagli Prodotto',
  'products.tabs.images': 'Immagini',
  'products.images.title': 'Immagini Prodotto',
  'products.images.primary': 'Principale',
  'products.images.uploadButton': 'Carica Immagini',
  'products.images.uploadInstructions': 'Seleziona più file • Max 5MB ciascuno',
  'products.images.manage': 'Gestisci Immagini',
  'products.images.tooManyFiles': 'Troppi file',
  'products.images.tooManyFilesDesc': 'Puoi caricare solo altre {count} immagine/i. Massimo 8 per prodotto.',
  'products.images.invalidFiles': 'File non validi',
  'products.images.invalidFilesDesc': '{count} file non sono validi (>5MB o non sono immagini)',
  'products.images.uploaded': 'Immagini caricate',
  'products.images.uploadedDesc': '{count} immagine/i caricate con successo',
  'products.images.partialUpload': 'Caricamento parziale',
  'products.images.uploadFailed': 'Caricamento fallito',
  'products.images.uploadFailedDesc': 'Impossibile caricare le immagini',
  'products.images.primaryUpdated': 'Immagine principale aggiornata',
  'products.images.primaryUpdatedDesc': 'Immagine principale impostata con successo',
  'products.images.deleted': 'Immagine eliminata',
  'products.images.deletedDesc': 'Immagine del prodotto eliminata con successo',
  'products.images.deleteFailed': 'Eliminazione fallita',
  'products.images.deleteFailedDesc': "Impossibile eliminare l'immagine",
  'products.images.updateFailed': 'Aggiornamento fallito',
  'products.images.updateFailedDesc': "Impossibile aggiornare la posizione dell'immagine",
  'products.images.uploading': 'Caricamento...',
  'products.images.files': '{count} file',
  'products.images.uploadingFiles': 'Caricamento File',
  'products.images.failed': 'Fallito',
  'products.images.noImages': 'Nessuna immagine caricata',
  'products.images.noImagesDesc': 'Carica immagini per mostrare il tuo prodotto',
  'products.images.description': '{current} di {max} immagini',
  'products.images.createFirst': 'Crea prima il prodotto per gestire le immagini',
  'products.edit.title': 'Modifica Prodotto',
  'products.edit.cancel': 'Annulla',
  'products.edit.updating': 'Aggiornamento...',
  'products.edit.update': 'Aggiorna Prodotto',
  'products.edit.success': 'Prodotto aggiornato con successo',
  'products.edit.error': "Errore nell'aggiornamento del prodotto",
  'products.edit.unsavedChanges': 'Modifiche non salvate',
  'products.edit.discard': 'Annulla modifiche',
  'products.edit.noImages': 'Nessuna immagine',
  'products.edit.loadingImages': 'Caricamento...',
  'products.sections.basicInfo': 'Informazioni Base',
  'products.sections.attributes': 'Attributi',
  'products.sections.pricing': 'Prezzo e Fornitore',
  'products.sections.stock': 'Gestione Magazzino',
  'products.delete.success': 'Prodotto eliminato con successo',
  'products.delete.error': "Errore nell'eliminazione del prodotto",
  'products.delete.confirmTitle': 'Eliminare il prodotto?',
  'products.delete.confirmDescription': 'Questa azione non può essere annullata. Il prodotto e tutti i dati associati verranno eliminati definitivamente.',
  'products.delete.confirm': 'Elimina',
  'products.notFound': 'Prodotto non trovato',
  'products.backToProducts': 'Torna ai Prodotti',
  'products.margin': 'Margine',
  'products.noTracking': 'Nessun tracciamento',
  'products.createTitle': 'Crea Nuovo Prodotto',
  'products.editTitle': 'Modifica Prodotto',
  'products.deleteTitle': 'Elimina Prodotto',
  'products.deleteConfirmation': 'Sei sicuro di voler eliminare questo prodotto? Questa azione non può essere annullata.',
  'products.actions.exportCsv': 'Esporta CSV',
  'products.actions.importCsv': 'Importa CSV',
  'products.actions.newProduct': 'Nuovo Prodotto',
  'products.actions.createProduct': 'Crea Prodotto',
  'products.actions.updateProduct': 'Aggiorna Prodotto',
  'products.success.created': 'Prodotto creato con successo',
  'products.success.updated': 'Prodotto aggiornato con successo',
  'products.success.deleted': 'Prodotto eliminato con successo',
  'products.fields.name': 'Nome*',
  'products.fields.category': 'Categoria*',
  'products.fields.brand': 'Marca',
  'products.fields.colour': 'Colore',
  'products.fields.sizeRange': 'Gamma Taglie',
  'products.fields.sellingPrice': 'Prezzo di Vendita (€)',
  'products.fields.costPrice': 'Prezzo di Costo (€)',
  'products.fields.internalOnly': '(Solo uso interno)',
  'products.fields.supplier': 'Fornitore',
  'products.fields.trackStock': 'Traccia Scorte',
  'products.fields.allowNegative': 'Consenti Scorte Negative',
  'products.fields.stockAvailable': 'Scorte Disponibili',
  'products.fields.quantityOnHand': 'Quantità Disponibile',
  'products.fields.description': 'Descrizione',
  'products.placeholders.name': 'Elegante Abito a Linea A',
  'products.placeholders.supplier': 'Seleziona fornitore (opzionale)',
  'products.debug.current': 'Corrente',
  'products.debug.total': 'Totale',

  // Legacy keys
  'new_product': 'Nuovo Prodotto',
  'export_csv': 'Esporta CSV',
  'export': 'Esporta',
  'create_new_product': 'Crea Nuovo Prodotto',
  'edit_product': 'Modifica Prodotto',
  'sku_required': 'SKU*',
  'style_name_required': 'Nome Stile*',
  'style_name': 'Nome Stile',
  'sku_placeholder': 'ABITO001',
  'style_name_placeholder': 'Elegante Abito A-Line',
  'brand_placeholder': 'Vera Wang',
  'colour_placeholder': 'Avorio',
  'size_range': 'Gamma Taglie',
  'size_range_placeholder': '6-20',
  'price_euro': 'Prezzo (€)',
  'price_placeholder': '1500',
  'stock_available': 'Scorte Disponibili',
  'stock_placeholder': '1',
  'image_url': 'URL Immagine',
  'table_sku': 'SKU',
  'table_style_name': 'Nome Stile',
  'table_brand': 'Marca',
  'table_size_range': 'Gamma Taglie',
  'table_colour': 'Colore',
  'table_price': 'Prezzo',
  'table_stock': 'Scorte',
  'table_actions': 'Azioni',
  'sku_already_exists': 'SKU già esistente. Utilizzare un SKU univoco.',
  'product_referenced_orders': 'Questo prodotto è riferito da ordini esistenti e non può essere eliminato',
  'product_created_successfully': 'Prodotto creato con successo',
  'product_updated_successfully': 'Prodotto aggiornato con successo',
  'product_deleted_successfully': 'Prodotto eliminato con successo',
  'failed_to_create_product': 'Impossibile creare il prodotto',
  'failed_to_update_product': 'Impossibile aggiornare il prodotto',
  'failed_to_delete_product': 'Impossibile eliminare il prodotto',
  'failed_to_fetch_products': 'Impossibile recuperare i prodotti',
  'confirm_delete_product': 'Sei sicura di voler eliminare questo prodotto?',
  'no_products_found': 'Nessun prodotto trovato',
};
